<template>
  <div>
    <div class="m-popup-mask" v-show="show" @click.stop="close"></div>
    <div :class="classes()" :style="styles()" v-show="show">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {addClass, removeClass, getScrollview} from '../assets/utils';

  export default {
    name: 'popup',
    data() {
      return {
        show: false
      };
    },
    props: {
      position: {
        validator(value) {
          return ['bottom', 'center', 'left', 'right'].indexOf(value) > -1;
        },
        default: 'bottom'
      },
      height: {
        type: String,
        default: '50%'
      },
      width: {
        type: String,
        default: '50%'
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value(val) {
        if (val && this.isIOS) {
          addClass(this.scrollView, 'fix-ios-bug');
        }
        this.show = val;
      }
    },
    methods: {
      styles() {
        switch (this.position) {
          case 'left':
            return {width: this.width};
          case 'right':
            return {width: this.width};
          case 'bottom':
            return {width: '100%', height: this.height};
          default:
            return {width: this.width};
        }
      },
      classes() {
        const pos = this.position === 'center' ? 'm-popup-center ' : 'm-popup ';
        const show = this.show ? 'popup-show ' : '';
        return `${pos} ${show} popup-${this.position}`;
      },
      close() {
        if (window.token) {
          if (this.isIOS) {
            removeClass(this.scrollView, 'fix-ios-bug');
          }
          this.show = false;
          this.$emit('input', false);
          this.$emit('popupcose');
        }
      }
    },
    mounted() {
      this.scrollView = getScrollview(this.$el);
      this.isIOS = !!((window.navigator && window.navigator.userAgent) || '').match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }
  };
</script>

<style lang="less">
  @import "../assets/base.less";

  .m-popup {
    position: fixed;
    background-color: #FFF;
    z-index: @base-zindex * 1500 + 1;
    transition: transform .3s;
    pointer-events: none;
    &.popup-left {
      transform: translate(-100%, 0);
      left: 0;
      top: 0;
      height: 100%;
    }
    &.popup-right {
      transform: translate(100%, 0);
      right: 0;
      top: 0;
      height: 100%;
    }
    &.popup-bottom {
      transform: translate(0, 100%);
      right: 0;
      bottom: 0;
      height: 100%;
      overflow: scroll;
    }
    &.popup-center {

    }
    &.popup-show {
      pointer-events: auto;
      transform: translate(0, 0);
    }
  }

  .m-popup-center {
    background-color: #FFF;
    z-index: @base-zindex * 1500 + 2;
    position: fixed;
    top: 50%;
    left: 50%;
    opacity: 0;
    transform: translate(-50%, -50%) scale(.8);
    transform-origin: 50% 50%;
    transition: all .1s;
    border-radius: 2px;
    pointer-events: none;
    &.popup-show {
      pointer-events: auto;
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .m-popup-mask {
    .mask(rgba(0, 0, 0, .4), @base-zindex * 1500);
  }
</style>



// WEBPACK FOOTER //
// Popup.vue?2182995a